import React from 'react';
import { useCustomerManagement } from './CustomerManagement/useCustomerManagement';
import CustomerFilters from './CustomerManagement/CustomerFilters';
import CustomerList from './CustomerManagement/CustomerList';
import CustomerDetailView from './CustomerManagement/CustomerDetailView';
import ActivationConfirmDialog from './CustomerManagement/ActivationConfirmDialog';
import GuestEmailEditDialog from './CustomerManagement/GuestEmailEditDialog';

export default function CustomerManagement() {
  const {
    customers, filteredCustomers, locations, staffMap, loading,
    searchTerm, setSearchTerm, typeFilter, setTypeFilter, statusFilter, setStatusFilter,
    selectedCustomer, customerDetails, detailsLoading,
    pendingAction, setPendingAction, toggling,
    emailEditOpen, setEmailEditOpen, emailDraft, setEmailDraft, savingEmail,
    viewCustomerDetails, closeDetails, handleConfirmToggle, openEmailEdit, handleSaveEmail,
  } = useCustomerManagement();

  return (
    <div data-testid="customer-management-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-4xl font-black font-heading uppercase">Customer Management</h1>
        <div className="text-sm text-muted-foreground">
          {customers.length} total customers
        </div>
      </div>

      <CustomerFilters
        searchTerm={searchTerm} setSearchTerm={setSearchTerm}
        typeFilter={typeFilter} setTypeFilter={setTypeFilter}
        statusFilter={statusFilter} setStatusFilter={setStatusFilter}
      />

      <div className="text-sm text-muted-foreground mb-4">
        Showing {filteredCustomers.length} of {customers.length} customers
      </div>

      {loading ? (
        <div className="text-center py-8 text-muted-foreground">Loading customers...</div>
      ) : selectedCustomer ? (
        <CustomerDetailView
          customerDetails={customerDetails}
          detailsLoading={detailsLoading}
          locations={locations}
          staffMap={staffMap}
          onBack={closeDetails}
          onEditEmail={openEmailEdit}
          onDeactivate={() => setPendingAction('deactivate')}
          onActivate={() => setPendingAction('activate')}
        />
      ) : (
        <CustomerList
          customers={customers}
          filteredCustomers={filteredCustomers}
          onSelect={viewCustomerDetails}
        />
      )}

      <ActivationConfirmDialog
        pendingAction={pendingAction}
        setPendingAction={setPendingAction}
        toggling={toggling}
        customerName={customerDetails?.customer?.name}
        onConfirm={handleConfirmToggle}
      />

      <GuestEmailEditDialog
        open={emailEditOpen}
        setOpen={setEmailEditOpen}
        hasExistingEmail={!!customerDetails?.customer?.email}
        emailDraft={emailDraft}
        setEmailDraft={setEmailDraft}
        savingEmail={savingEmail}
        onSave={handleSaveEmail}
      />
    </div>
  );
}
